"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Minus = (0, _createIcon["default"])({
  path: 'M1 9C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7L15 7C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9L1 9Z',
  // prettier-ignore
  viewBox: '16 16',
  icon: 'minus',
  displayName: 'Minus'
});
var _default = exports["default"] = Minus;